// @owners { team: patients }
import { BORDERS, SPACING } from '@alto/design-library-tokens';
import React from 'react';
import { Dimensions, Image, type ImageSourcePropType, Modal, TouchableOpacity, View } from 'react-native';
import styled from 'styled-components/native';

const ModalBackground = styled(TouchableOpacity)`
  background-color: rgba(0, 0, 0, 0.5);
  flex: 1;
  justify-content: center;
  padding: ${SPACING.STATIC.LG.px};
`;

const ModalBody = styled(View)`
  align-items: center;
  border-radius: ${BORDERS.RADIUS.XS.px};
`;

const MedicationImage = styled(Image)`
  width: ${Dimensions.get('window').width * 0.9}px;
  height: ${Dimensions.get('window').height * 0.9}px;
`;

type Props = {
  readonly onClose: () => void;
  readonly show: boolean;
  readonly source: string | null | undefined;
};

export const MedImageModal: React.FC<Props> = ({ onClose, show, source }) => {
  return (
    <Modal
      transparent
      animationType="fade"
      onRequestClose={onClose}
      visible={show}
    >
      <ModalBackground
        activeOpacity={1}
        onPressOut={onClose}
      >
        <ModalBody>
          <MedicationImage
            source={{ uri: source } as ImageSourcePropType}
            resizeMode="contain"
          />
        </ModalBody>
      </ModalBackground>
    </Modal>
  );
};
